import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { progressActions } from '../actions/progress.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { HttpService } from '../services/http.service';

@Injectable({
    providedIn: 'root',
})
export class ProgressEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getProgress$ = createEffect(() => {
        return this.actions.pipe(
            ofType(progressActions.getProgress, progressActions.markAsCompletedSuccess, progressActions.markAsUncompletedSuccess),
            mergeMap(() => {
                return this.httpService.getProgress().pipe(
                    map((payload) => progressActions.getProgressSuccess({ payload })),
                    catchError(() => of(progressActions.getProgressError())),
                );
            }),
        );
    });

    markAsCompleted$ = createEffect(() => {
        return this.actions.pipe(
            ofType(progressActions.markAsCompleted),
            mergeMap(({ value }) => {
                return this.httpService.markLessonAsCompleted(value).pipe(
                    map(() => progressActions.markAsCompletedSuccess()),
                    catchError(() => of(progressActions.markAsCompletedError())),
                );
            }),
        );
    });

    markAsUncompleted$ = createEffect(() => {
        return this.actions.pipe(
            ofType(progressActions.markAsUncompleted),
            mergeMap(({ value }) => {
                return this.httpService.markLessonAsUncompleted(value).pipe(
                    map(() => progressActions.markAsUncompletedSuccess()),
                    catchError(() => of(progressActions.markAsUncompletedError())),
                );
            }),
        );
    });
}
